import { required, minLength, email } from 'vuelidate/lib/validators';
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';

const categories = [
  'General',
  'Error',
  'User Experience',
  'Suggestion',
];

export default {
  name: 'feedback-form',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    categories,
    email: '',
    firstName: '',
    lastName: '',
    category: categories[0],
    comment: '',
  }),
  computed: {
    loggedIn() {
      return this.$store.getters['auth/loggedIn'];
    },
    userEmail() {
      return this.$store.getters['auth/getUserEmail'] || '';
    },
    userFirstName() {
      return this.$store.getters['auth/getUserGivenName'] || '';
    },
    userFamilyName() {
      return this.$store.getters['auth/getUserFamilyName'] || '';
    },
  },
  methods: {
    clearData() {
      this.email = '';
      this.firstName = '';
      this.lastName = '';
      // eslint-disable-next-line prefer-destructuring
      this.category = categories[0];
      this.comment = '';
      this.$v.$reset();
    },
    handleClose() {
      this.clearData();
      this.$emit('close');
    },
    handleSend() {
      this.$v.$touch();
      if (!this.$v.$error) {
        const feedback = {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          subject: this.category,
          message: this.comment,
        };
        API.post(ENDPOINTS.POST_FEEDBACK, feedback)
          .then((response) => {
            if (response.status === 200) {
              EventBus.$emit('addNotification', {
                title: 'Thank you for your feedback.',
                icon: 'tick',
                message: 'Successfully sent!',
              });
            }
          })
          .catch(() => {
            EventBus.$emit('addNotification', {
              title: 'Thank you for your feedback.',
              icon: 'cross',
              message: 'An error has occured sending.',
            });
          });
        this.handleClose();
      }
    },
    setUser() {
      this.email = this.userEmail;
      this.firstName = this.userFirstName;
      this.lastName = this.userFamilyName;
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          this.setUser();
        }
      },
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    firstName: {
      required,
      minLength: minLength(2),
    },
    lastName: {
      required,
      minLength: minLength(2),
    },
    comment: {
      required,
      minLength: minLength(2),
    },
  },
};
